import { MenuItem, Skeleton } from '@mui/material'
import TextField, {TextFieldProps} from '@mui/material/TextField'

type InputProps = TextFieldProps & {
    options?: {
        value: number | string
        label: string
    }[]
    loading?: boolean
}

export const Input = (props: InputProps) => {
    if (props.loading) {
        return (
            <Skeleton height={60} />
        )
    }

    if (props.select) {
        return <TextField fullWidth variant='outlined' {...props}>
            {
                props.options?.map(option => {
                    return (
                        <MenuItem key={option.value} value={option.value}>
                            {option.label}
                        </MenuItem>
                    )
                })
            }
        </TextField>
    }

    return <TextField fullWidth {...props} />
}